import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { PatternFormat } from 'react-number-format';
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import Loading from '../Loading/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchInput from '../SearchInput/SearchInput';

function getValueByPath(obj, path) {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : undefined;
  }, obj);
}

export default function Input(props) {
  const { resetSearch, isComment, format, rows = 4, classNameWrap, label, error, disabled, rules = { required: { value: true, message: '*Обязательное поле для заполнения' } }, placeholder, form, name, type, className, list, onSearch = () => {}, sliceName, actionName, onKeyDown = () => {} } = props;
  const errorForm = form?.formState?.errors?.[name];
  const [search, setSearch] = useState();

  useEffect(() => {
    const timeout = setTimeout(() => {
      console.log('search');

      if (search !== undefined) {
        form.setValue(name, search);
        form.setValue('filterTouch', true);
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    if (resetSearch) {
      setSearch();
    }
  }, [resetSearch]);

  // console.log(search);

  return (
    <div className={classNameWrap}>
      {label && (
        <div className="flex flex-wrap justify-between zero:items-end">
          <label htmlFor="name" className="block mb-2 text-sm font-bold text-gray-900">
            {label} {rules?.required?.value && <span class="text-red-500">*</span>}
          </label>

          {isComment && <input type="text" class="block w-1/2 px-2.5 text-gray-900 text-sm shadow-sm border border-b-1 border-b-gray-500 focus:border-b-blue-400 focus:outline-none mb-2" placeholder="Комментарии менеджера" {...form?.register(`comments.${name}`, { required: false })}></input>}
        </div>
      )}
      {type == 'textarea' ? (
        <textarea
          rows={rows}
          class={clsx(
            `w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6`,
            className,
            (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
          )}
          disabled={disabled}
          autoComplete="off"
          data-1p-ignore
          data-lpignore="true"
          name={name}
          type={type}
          placeholder={placeholder}
          onKeyUp={onKeyDown}
          {...form?.register(name, rules)}></textarea>
      ) : type == 'select' ? (
        <div class="relative">
          <select
            class={clsx(
              `appearance-none w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6 disabled:bg-gray-100`,
              className,
              (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
            )}
            disabled={disabled}
            autoComplete="off"
            data-1p-ignore
            data-lpignore="true"
            name={name}
            placeholder={placeholder}
            {...form?.register(name, rules)}>
            {list?.map((option) => (
              <option value={option?.value}>{option?.label}</option>
            ))}
          </select>{' '}
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      ) : type == 'phone' ? (
        <PatternFormat
          class={clsx(
            `w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6`,
            className,
            (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
          )}
          format="+ 7 (###) ###-##-##"
          value={form.watch(name)}
          mask="*"
          type="text"
          placeholder={placeholder}
          autoComplete="off"
          is
          disabled={disabled}
          onValueChange={(val) => {
            // form.setValue(`${name}Formatted`, val.formattedValue);
            form.setValue(name, val.floatValue);
          }}
        />
      ) : type == 'format' ? (
        <Controller
          control={form.control}
          name={name}
          rules={rules}
          render={({ field: { onChange, ...props } }) => (
            <PatternFormat
              class={clsx(
                `w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6`,
                className,
                (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
              )}
              format={format}
              value={form.watch(name)}
              mask="*"
              type="text"
              placeholder={placeholder}
              autoComplete="off"
              is
              disabled={disabled}
              onValueChange={(val) => {
                // form.setValue(`${name}Formatted`, val.formattedValue);
                onChange(val.floatValue);
                // form.setValue(name, val.floatValue);
              }}
              {...props}
            />
          )}
        />
      ) : type == 'search-select' ? (
        <>
          <SearchInput {...props} />
        </>
      ) : type == 'search' ? (
        <input
          type="text"
          autoComplete="off"
          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
          placeholder={placeholder}
          value={search ?? ''}
          {...form.register(name)}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      ) : (
        <input
          class={clsx(
            `w-full block w-full rounded-md border border-1 border-gray-300 focus:border-button px-3.5 py-2 text-gray-900 shadow-sm   placeholder:text-gray-400  focus:outline-none sm:text-sm sm:leading-6`,
            className,
            (errorForm || error) && 'border-red-300 focus:border-red-500 placeholder:text-red-400',
          )}
          disabled={disabled}
          onKeyUp={onKeyDown}
          autoComplete="off"
          data-1p-ignore
          data-lpignore="true"
          name={name}
          type={type}
          {...(type == 'date' && { 'data-date-format': 'DD-MM-YYYY' })}
          placeholder={placeholder}
          {...form?.register(
            name,
            type == 'email'
              ? {
                  ...rules,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Не верный формат почты',
                  },
                }
              : rules,
          )}
        />
      )}

      {errorForm && <div className="text-sm text-red-400 mt-1">{errorForm?.message}</div>}
      {error && <div className="text-sm text-red-400 mt-1">{error}</div>}
    </div>
  );
}
